import React, {useMemo} from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames/bind'

import SectionLoader from '../SectionLoader'
import TitledListItem from '../TitledListItem'
import Badge from 'js/components/shared/Badge'

import styles from './FamiliesAndPetsSection.module.scss'

const cx = classnames.bind(styles);

const FamiliesAndPetsSection = function ({
  isLoading,
  info = {},
  className = ''
}) {
  const sections = useMemo(function () {
    return !isLoading
      ? Object.values(info).sort((a, b) => a.order > b.order ? 1 : -1)
      : []
  }, [isLoading, info])

  return (
    <div className={cx('root', className)}>
      {isLoading && (<SectionLoader />)}
      {!isLoading && sections.map((section, i) => (
        <TitledListItem title={section.label} key={i} >
          {section.listDescription && (<p>{section.listDescription}</p>)}
          {section.description && (<p>{section.description}</p>)}
          {!!section.list?.length && (
            <ul>
              {section.list.map((el, i) => (
                <li key={el.code || i}>
                  {el.label}
                  {el.description}
                  {el.paying && (<Badge className={cx('tag')} color="gray" theme="semi-round">{el.paying}</Badge>)}
                </li>
              ))}
            </ul>
          )}
        </TitledListItem>
      ))}
    </div>
  )
}

FamiliesAndPetsSection.propTypes = {
  data: PropTypes.any
}

export default FamiliesAndPetsSection;
